import { Theme, useMediaQuery } from '@mui/material'

export function useBreakpoints() {
  const isMd = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'))

  return {
    isMd,
  }
}
